import { useEffect, useState } from "react";
import { Irpd } from "../../redux/irpds/types";
import checkExists from "../../utils/checks/checkExists";
import { coreHTTPClient } from "../../services/webclient";
import { useRecoilState } from "recoil";
import { IrpdStateList } from "../../recoils/IrpdRecoil";

const useIrpds = (
  farmID: number,
  useFromCacheIfPossible?: boolean
): [boolean, Irpd[], () => Promise<void>] => {
  const [loading, setLoading] = useState(false);

  const [irpds, setIrpds] = useRecoilState(IrpdStateList);

  async function getIrpds() {
    await new Promise(async (resolve) => {
      setLoading(true);
      try {
        const response = await coreHTTPClient.get(`v3/farms/${farmID}/irpds/`);
        if (checkExists(["data", response, "__cascade"])) {
          setIrpds(response.data);
        }
      } catch (err) {
      } finally {
        setLoading(false);
      }
    });
  }

  useEffect(() => {
    if (useFromCacheIfPossible && irpds.length != 0) return;

    getIrpds();
    // eslint-disable-next-line
  }, [farmID]);

  return [loading, irpds, getIrpds];
};

export default useIrpds;
